export default "__VITE_ASSET__6e9b8931__"